import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CardActivateFiltering } from './Pages';

export const CardActivateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CardActivateFiltering} />
    </Fragment>
)